import { useLingui } from "@lingui/react";
import { ConfirmDialog } from "@/components/ui/confirm-dialog";

export interface DiscardChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Runs when the user chooses to discard; the dialog closes afterwards. */
  onConfirm: () => void;
}

/**
 * The one "leave with unsaved edits?" question of the app. Opened by
 * `useDirtyGuard`; "Keep editing" is the safe default, so it is the cancel.
 */
export function DiscardChangesDialog({
  open,
  onOpenChange,
  onConfirm,
}: DiscardChangesDialogProps) {
  const { i18n } = useLingui();

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="destructive"
      title={i18n._({ id: "form.discard.title", message: "Discard changes?" })}
      description={i18n._({
        id: "form.discard.description",
        message: "Your edits on this page are not saved.",
      })}
      confirmLabel={i18n._({ id: "prospects.form.discardConfirm", message: "Discard" })}
      cancelLabel={i18n._({ id: "accessRoles.discard.cancel", message: "Keep editing" })}
      onConfirm={onConfirm}
    />
  );
}
